import { createStore } from 'redux'
import { handleActions } from 'redux-actions'

type TCreateStoreWrapperArgs = {
  domainWidth: number,
}
type TCreateStoreWrapper = (args: TCreateStoreWrapperArgs) => Object
let createStoreWrapper: TCreateStoreWrapper = ({ domainWidth }): Object => {
  let initialState = {
    animating: false,
    min: 0,
    max: domainWidth,
    startMin: 0,
    startMax: domainWidth,
    targetMin: 0,
    targetMax: domainWidth,
    domain: domainWidth,
    currentAnimationIteration: 0,
    consequenceFilters: [],
    impactFilters: [],
    dragging: false,
    zoomStart: null,
    sliding: false,
    slideStart: null,
    slideStartMin: null,
    slideStartMax: null,
    type: `Consequence`,
  }

  let reducer = handleActions({
    UPDATE: (state, action) => ({ ...state, ...action.payload }),
  }, initialState)

  let store = createStore(reducer)
  store.update = payload => store.dispatch({ type: `UPDATE`, payload })

  return store
}

export default createStoreWrapper



// WEBPACK FOOTER //
// ./modules/~/@oncojs/lolliplot/store.js